import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthShell, Field } from "./AuthShell";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent.");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset password" subtitle="Enter your email to receive a reset link"
      footer={<><Link to="/login" className="text-cyan-400 hover:underline">Back to Login</Link></>}>
      {sent ? (
        <div className="glass rounded-xl p-6 text-center" data-testid="forgot-sent">
          <p className="text-slate-300 text-sm">If an account exists for <strong>{email}</strong>, a password reset link has been sent. Please check your inbox.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email" testId="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
          <button type="submit" disabled={loading} data-testid="forgot-submit"
            className="btn-glow w-full py-3 rounded-lg font-semibold text-slate-950 inline-flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send Reset Link
          </button>
        </form>
      )}
    </AuthShell>
  );
}
